import GuidePage from "@/components/guide-page";

export default function GuideSummerSafety() {
  return (
    <GuidePage
      eyebrow="Free Guide · Tallahassee Lassie"
      title="Tallahassee Summer Dog Safety: Beating the Heat"
      metaTitle="Tallahassee Summer Dog Safety Guide"
      metaDescription="How to keep your dog safe in Tallahassee's summer heat and humidity: hot-pavement checks, hydration, the best times to walk, and the warning signs of heatstroke."
      path="/resources/summer-safety"
      heroImg="https://images.squarespace-cdn.com/content/v1/61a9415d512d9d24f6cc2d59/b885628e-de6b-49d7-bf64-f592f9783add/DogWalker.jpg"
      intro="Tallahassee summers are no joke — high heat plus North Florida humidity means it can feel dangerous out there long before noon. Dogs cool themselves far less efficiently than we do, so a walk that feels fine to you can be risky for them. Here's how our team keeps pups safe all season long."
      sections={[
        {
          heading: "Do the 7-second pavement test",
          body: "Asphalt and dark sidewalks soak up heat and can scorch paw pads. Before you head out, press the back of your hand to the pavement. If you can't hold it comfortably for 7 seconds, it's too hot for paws. Stick to grass and shaded greenways, or wait for a cooler hour.",
        },
        {
          heading: "Walk early or late — skip the middle of the day",
          body: "In Tallahassee summers, aim for before 9 a.m. or after 7 p.m. when the pavement and air have cooled. Midday walks are when most heat trouble happens. If your dog still needs to burn energy at midday, an air-conditioned play session indoors is safer than a hot walk.",
        },
        {
          heading: "Hydration & shade on every outing",
          checklist: [
            "Bring water and a collapsible bowl for anything longer than a quick let-out.",
            "Choose routes with tree cover — our local greenways and canopy roads are perfect.",
            "Take breaks in the shade; don't push for distance on humid days.",
            "Never leave a pet in a parked car, even for a minute — interiors heat up fast.",
          ],
        },
        {
          heading: "Know the warning signs of heatstroke",
          body: "Heatstroke is an emergency. Watch for heavy or frantic panting, thick drooling, bright red gums, wobbliness or weakness, vomiting, or collapse. Flat-faced breeds (bulldogs, pugs), seniors, puppies, and overweight dogs are at higher risk.",
        },
        {
          heading: "If you suspect heatstroke, act fast",
          checklist: [
            "Move your dog to shade or air conditioning immediately.",
            "Offer small amounts of cool (not ice-cold) water.",
            "Wet them with cool water on the belly, paws, and armpits.",
            "Call your vet or a Tallahassee emergency animal hospital right away — heatstroke can worsen even after they seem to recover.",
          ],
        },
        {
          heading: "How we handle the heat",
          body: "Our walkers adjust timing, shorten outings on dangerous days, always carry water, and will swap a hot walk for indoor enrichment or a let-out when conditions call for it. For dogs who need to truly get out, our Pupventures outings head to shaded parks and greenways — and we never compromise on safety.",
        },
      ]}
      ctaHeading="Too hot to keep up with midday walks?"
      ctaBody="Let us cover the midday shift so your pup stays safe and happy. Book a free call and we'll build a summer-smart routine together."
    />
  );
}
